module.exports = __webpack_public_path__ + "static/media/makeapledge.fb66940b.png";